<template>
  <v-card v-if="modulet.length">
    <v-card-title>
      <v-icon color="primary">mdi-toggle-switch-outline</v-icon>
      <span class="pl-2">{{ $t('modules.title') }}</span>
    </v-card-title>
    <v-card-text>
      <p class="text-caption grey--text mb-4">{{ $t('modules.subtitle') }}</p>

      <div v-for="m in modulet" :key="m.key" class="moduli">
        <div class="moduli__tekst">
          <div class="moduli__emer">{{ emri(m) }}</div>
          <div class="moduli__pershkrim">{{ pershkrimi(m) }}</div>
        </div>
        <v-switch
          v-model="m.enabled"
          :disabled="duke === m.key"
          :loading="duke === m.key"
          color="success"
          hide-details
          class="mt-0 pt-0"
          @change="ndrysho(m, $event)"
        ></v-switch>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
/**
 * Modulet e nje organizate, te ndezura ose te fikura nga admini i platformes.
 *
 * Lista nuk eshte e shkruar ketu: vjen nga `config/modules.php` ne server,
 * ndaj nje modul i ri shfaqet vete pa prekur kete faqe.
 */
import axios from 'axios';
import { mesazhiIGabimit } from '@/utils/error-message';

export default {
  props: {
    school: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modulet: [],
      duke: null,
    };
  },
  mounted() {
    this.merr();
  },
  methods: {
    gjuha() {
      return localStorage.getItem('locale') === 'en' ? 'en' : 'sq';
    },
    emri(m) {
      return m.name[this.gjuha()] || m.name.en;
    },
    pershkrimi(m) {
      return m.description[this.gjuha()] || m.description.en;
    },

    async merr() {
      try {
        const { data } = await axios.get('/school-modules', {
          params: { school_id: this.school.id },
        });
        this.modulet = data.modules || [];
      } catch (e) {
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      }
    },

    async ndrysho(moduli, vlera) {
      this.duke = moduli.key;
      try {
        await axios.post('/school-modules', {
          school_id: this.school.id,
          module: moduli.key,
          enabled: vlera,
        });
      } catch (e) {
        // Kthehet aty ku ishte: nje celes qe tregon nje gjendje tjeter nga
        // ajo e serverit eshte me keq se nje gabim i dukshem.
        moduli.enabled = !vlera;
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      } finally {
        this.duke = null;
      }
    },
  },
};
</script>

<style scoped>
.moduli {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  border-top: 1px solid #eceff1;
}
.moduli:first-of-type {
  border-top: 0;
}
.moduli__tekst {
  flex: 1;
}
.moduli__emer {
  font-weight: 600;
}
.moduli__pershkrim {
  font-size: 0.78rem;
  color: #78909c;
  line-height: 1.4;
}
</style>
